import { MIN_SEARCH_NAME_LENGTH } from "../constants/validation";

/**
 * Checks whether given `name` satisfies the length requirement
 * @param name
 */
export function isSavedSearchNameLongEnough(name: string) {
    return name.trim().length >= MIN_SEARCH_NAME_LENGTH;
}
